import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Card1, Card2, Card3, Card4 } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { getScheduleStatisticsThunk } from '../../redux/schedulecartslice';



const ToolCards = () => {
    const dispatch = useDispatch()
    const { scheduletatistics } = useSelector((state) => state.schedule);
    const data = scheduletatistics?.data
    console.log(scheduletatistics);


    useEffect(() => {
        dispatch(getScheduleStatisticsThunk())
    }, [])
    const statuses = [
        {
            title: 'New',
            count: data?.NEW?.totalCount || 0,

            icon: <Card1 />,
        },

        {
            title: 'Completed',
            count: data?.COMPLETED?.totalCount || 0,

            icon: <Card3 />,
        },

    ];
  
    return (
        <Box sx={{ paddingBottom: '16px' }}>
            <Grid container spacing={2}>
                {statuses.map((status, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{
                            display: 'flex', alignItems: 'flex-start', boxShadow: "none",
                            justifyContent: 'space-between', border: '1px solid #E0E2E7',
                        }}>
                            <CardContent>
                                <Typography variant="subtitle1" color="#777980" fontSize="16px">
                                    {status.title}
                                </Typography>
                                <Typography variant="h5" color="#1D1F2C" sx={{ p: '6px 0' }} fontSize="28px">
                                    {status.count}
                                </Typography>
                                <Typography variant="body2" color="#858D9D" fontSize="14px">
                                    {status.today}
                                </Typography>
                            </CardContent>
                            <Box sx={{ p: 2 }}>{status.icon}</Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
      
    );
};

export default ToolCards;
